import { render, staticRenderFns } from "./veStuHealthReportEdit.vue?vue&type=template&id=57131ef9&scoped=true"
import script from "./veStuHealthReportEdit.vue?vue&type=script&lang=js"
export * from "./veStuHealthReportEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57131ef9",
  null
  
)

export default component.exports